<template>
  <div class="tw-p-4 tw-flex tw-justify-end tw-pointer-events-none">
    <div class="tw-flex tw-items-center tw-gap-2 tw-pointer-events-auto">
      <add-to-project :projectsUrl="projectsUrl"
                      v-if="projectsUrl"
                      buttonClass="tw-invisible group-hover:tw-visible btn-round-icon"
                      :projectAssetsUrl="projectAssetsUrl"
                      :assetId="asset.objectID">
        <template #button-slot>
          <i class="fas fa-folder-open tw-w-4 tw-h-4"/>
        </template>
      </add-to-project>

      <a class="cursor-pointer tw-invisible group-hover:tw-visible btn-round-icon"
         v-b-tooltip
         v-if="asset.type !== 'Video'"
         title="Preview"
         @click="$emit('preview', asset)">
        <i class="fas fa-search-plus tw-w-4 tw-h-4"></i>
      </a>

      <a :href="compUrl"
         class="tw-invisible group-hover:tw-visible btn-round-icon"
         target="_blank"
         v-b-tooltip
         title="Download Comp">
        <i class="fas fa-download tw-w-4 tw-h-4"></i>
      </a>

      <a :href="assetPublicUrl(asset)"
         class="tw-invisible group-hover:tw-visible btn-round-icon"
         v-b-tooltip
         title="View Details">
        <i class="fas fa-images tw-w-4 tw-h-4"></i>
      </a>
    </div>
  </div>
</template>
<script>
import AddToProject from "../Customers/Dashboard/AddToProject.vue";
import GeneralMixins from "../../mixins/GeneralMixins";

export default {
  mixins: [GeneralMixins],
  components: {AddToProject},

  props: [
    'asset',
    'projectsUrl',
    'projectAssetsUrl'
  ],

  computed: {
    isVideo() {
      return this.asset.type === "Video"
    },

    compUrl() {
      if (this.isVideo) {
        return this.asset.video_url
      } else {
        return this.asset.watermark_medium_url
      }
    }
  },
}
</script>